import React from "react";
import {
	Button,
	FormGroup,
	Form,
	Row,
	Col,
	Card,
	Container, Modal,
} from "react-bootstrap";
import { Formik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../../AuthUser";
import API from "../../api";
import {Helmet} from "react-helmet";
import VideoUpload from "../VideoUpload";
import {useNavigate} from "react-router-dom";
import {CreditCard, PaymentForm} from "react-square-web-payments-sdk";
import { SQUARE_APP_ID, SQUARE_LOCATION_ID } from "../../squareConfig";
import api from "../../api";
import {useState} from "react";
import { buildVerificationDetails, useSquareVerificationGuard } from "./squareSCA";

const UpdatePayment = () => {
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const navigate = useNavigate();
	const { user } = useAuth();

	const notify = (message) =>
		toast.success(message, {
			position: toast.POSITION.TOP_RIGHT,
		});

	const notifyError = (message) =>
		toast.error(message, {
			position: toast.POSITION.TOP_RIGHT,
		});

	const { startGuard, clearGuard } = useSquareVerificationGuard({ notify: notifyError });

	function isValidDate(s) {
		// Assumes s is "mm/dd/yyyy"
		return moment(s, 'YYYY-MM-DD',true).isValid()

	}
	const cancelSubscription = async () => {
		if(window.confirm("Are you sure you want to cancel your subscription?")) {
			try {
				await API.get('pay/subscriptions/cancel');
				notify("Successfully cancelled subscription");
				navigate('/dna-profile');
			} catch (err) {
				// A failed cancel used to look successful (MGDWD-183) — surface it.
				notifyError(err.response?.data?.message || "Could not cancel your subscription — please contact support@mygolfdna.com");
			}
		}
	}


	return (
		<>
			<Helmet>
				<title>Update Payment | MyGolfDNA.com</title>
				<meta name="description" content="update payment details"/>
			</Helmet>
			<div className="mt-4">
				<Container>

					<Row>
						<Col sm={12} md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }} xl={{ span: 6, offset: 3 }}>
							<div className="mt-3 d-grid gap-3 text-center">
								<h5 className="mb-3">Your Billing Details</h5>
								<p>Update your card on file for your current subscription</p>
								<PaymentForm
									applicationId={SQUARE_APP_ID}
									createVerificationDetails={() => buildVerificationDetails({ user })}
									cardTokenizeResponseReceived={async (token, verifiedBuyer) => {
										clearGuard();
										handleShow();
										await api.post("/pay/update", {
											sourceId: token.token,
											verificationToken: verifiedBuyer?.token,
										}).then(resp => {
											handleClose();
											// The API reports whether a paused (delinquent)
											// subscription was auto-resumed after the card swap.
											notify(resp?.data?.resumed
												? 'Card updated — your subscription has been resumed'
												: 'successfully updated payment details')
											navigate("/dna-profile", { replace: true });
										}).catch(err => {
											handleClose();
											notifyError(err.response?.data?.message || 'Could not update your card — please try again or contact support@mygolfdna.com');
										})
									}}
									locationId={SQUARE_LOCATION_ID}
								>
									{/* onClickCapture, not buttonProps.onClick: the SDK's own click
									handler calls stopPropagation() before React's synthetic event
									system sees it, so an onClick passed via buttonProps never fires.
									Capture phase runs before that native handler does. */}
									<div onClickCapture={startGuard}>
										<CreditCard
											buttonProps={{
												css: {
													backgroundColor: "#157729",
													fontSize: "14px",
													color: "#fff",
													"&:hover": {
														backgroundColor: "#1f8c44",
													},
												},
											}}
										>
											Update Card
										</CreditCard>
									</div>
								</PaymentForm>

							</div>


						</Col>
					</Row>
					<Modal
						show={show}
						onHide={handleClose}
						backdrop="static"
						keyboard={false}
					>
						<Modal.Body>
							<div className="text-center">
								<p>Updating Payment Details...</p>
								<div className="spinner-border" role="status">
									<span className="visually-hidden">Loading...</span>
								</div>
							</div>
						</Modal.Body>
					</Modal>
				</Container>

			</div>
		</>
	);
};

export default UpdatePayment;
